// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__S8pGD","brand":"Navbar_brand__Fmk0Y","navLinks":"Navbar_navLinks__Eyuuy","navLink":"Navbar_navLink__A7XgH","active":"Navbar_active__W-5S4"};